import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { addIcons } from 'huk-foundation';
import { refreshIcons } from 'huk-foundation/icons';
import { AppModule } from './app/app.module';
// import { environment } from './environments/environment';
import {env} from './environments/environment-loader';
if (env.production) {
  enableProdMode();
}

 addIcons(refreshIcons); // Add all refresh-themed icons

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

